import { render, staticRenderFns } from "./pointer.vue?vue&type=template&id=5f3f4844&scoped=true&"
import script from "./pointer.vue?vue&type=script&lang=js&"
export * from "./pointer.vue?vue&type=script&lang=js&"
import style0 from "./pointer.vue?vue&type=style&index=0&id=5f3f4844&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3f4844",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/merchant_5Yxh/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f3f4844')) {
      api.createRecord('5f3f4844', component.options)
    } else {
      api.reload('5f3f4844', component.options)
    }
    module.hot.accept("./pointer.vue?vue&type=template&id=5f3f4844&scoped=true&", function () {
      api.rerender('5f3f4844', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/customPage/pointer.vue"
export default component.exports